<template>
  <div style="height: 100%;">
    <sj-layout
      :collapse="collapse"
      :loading="loading">
      <template v-slot:aside>
        <!--      <sj-layout-logo :url="logoUrl"-->
        <!--                      :collapse-url="collapseLogoUrl"-->
        <!--                      style="filter: brightness(0) invert(1);opacity: 0.90;"/>-->
        <aside-logo value="DocAI"/>
        <default-layout-menus/>
      </template>
      <template v-slot:header>
        <div style="display: flex;justify-content: space-between;">
          <div>
            <sj-layout-collapse-button @click="collapse=!collapse"/>
          </div>
          <div>
            <router-link to="/login" v-if="!me">
            <el-button type="text">登录</el-button>
            </router-link>
            <sj-layout-user-dropdown v-else>
              <template v-slot:name>{{ me.name }}</template>
              <template v-slot:item>
                <el-dropdown-item>
                  <router-link to="/modify-password">
                    <span class="sj-icon-change-password"> 修改密码</span>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="logout">
                  <span class="sj-icon-logout"> 退出登录</span>
                </el-dropdown-item>
              </template>
            </sj-layout-user-dropdown>
          </div>
        </div>
      </template>
      <template v-slot:main>
        <sj-exception-page
          v-if="exception.code"
          :code="exception.code"
          :message="exception.message"/>
        <router-view v-else></router-view>
      </template>
      <template v-slot:footer>
        <span>© 2018, Inc. · Privacy · Terms · </span>
        <span>Versions {{ version }}</span>
      </template>
    </sj-layout>
    <login-dialog ref="loginDialog"/>
  </div>
</template>

<script>
// import collapseLogoUrl from '@/assets/logo.svg'
// import logoUrl from '@/assets/logo-horizontal.svg'
import DefaultLayoutMenus from './DefaultLayoutMenus'
import AsideLogo from './AsideLogo'
import LoginDialog from '../../views/auth/components/LoginDialog'

export default {
  name: 'DefaultLayout',
  components: {
    LoginDialog,
    AsideLogo,
    DefaultLayoutMenus,
  },
  data () {
    return {
      // logoUrl,
      // collapseLogoUrl,
      collapse: false,
      version: process.env.VUE_APP_VERSION,
      exception: this.$router.exception,
      me: auth.me,
    }
  },
  computed: {
    ...Vuex.mapGetters('layout', [
      'loading',
    ]),
    ...Vuex.mapState('layout', [
      'visibleLoginDialog',
    ]),
  },
  watch: {
    visibleLoginDialog () {
      if (this.visibleLoginDialog) {
        this.$refs.loginDialog.open()
      }
    },
  },
  mounted () {
    if (this.visibleLoginDialog) {
      this.$refs.loginDialog.open()
    }
  },
  methods: {
    async logout () {
      await this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      })
      await auth.logout()
      await this.$router.push(filter.loginPath(this.$route.fullPath))
    },
  },
}
</script>

<style>
</style>
